import {useTranslation} from 'react-i18next';
import InfoCircle from '../../../../../assets/icons/InfoCircle';
import {PhoneChangeMode} from '../../utils';
import {formatCurrentPhoneDisplay} from '../../utils';
import * as css from './InfoBanner.css';

type Props = {
    mode: PhoneChangeMode;
    phone: string;
};

export default function InfoBanner({mode, phone}: Props) {
    const {t} = useTranslation('layout');
    const modeSuffix = (mode.charAt(0).toUpperCase() + mode.slice(1)) as 'Regular' | 'Secure';

    return (
        <css.infoBanner>
            <css.infoBannerInner>
                <InfoCircle />
                <css.infoBannerText>
                    <css.infoBannerTitle>
                        {t(`orderChangePhoneInfoTitle${modeSuffix}`)}
                    </css.infoBannerTitle>
                    <css.infoBannerBody>
                        {t(`orderChangePhoneInfoBody${modeSuffix}`, {phone: formatCurrentPhoneDisplay(phone)})}
                    </css.infoBannerBody>
                </css.infoBannerText>
            </css.infoBannerInner>
        </css.infoBanner>
    );
}
